import { cx } from '@emotion/css';
import { RefObject, useCallback, useState } from 'react';

import { useResponsiveSizing } from './hooks';
import {
  actionClassName,
  disabledActionClassName,
  iconClassName,
  rightActionClassName,
} from './styles';

interface Props {
  parentRef: RefObject<$TSFixMe>;
  presentationRef: RefObject<$TSFixMe>;
  children: $TSFixMe;
}

export default function ArrowRight({
  parentRef,
  presentationRef,
  children,
}: Props) {
  const [isScrolling, setScrolling] = useState(false);
  const sizing = useResponsiveSizing({
    parentRef,
    presentationRef,
    children,
  });

  const handleRight = useCallback(() => {
    if (isScrolling) return;
    setScrolling(true);
    const { scrollLeft } = parentRef.current;
    const numElapsed = Math.ceil(scrollLeft / sizing.itemWidth) + sizing.limit;
    const willOverflow = numElapsed + sizing.limit >= children.length;
    var distance = willOverflow
      ? presentationRef.current.offsetWidth -
        parentRef.current.offsetWidth -
        scrollLeft
      : numElapsed * sizing.itemWidth - scrollLeft;
    let ref = presentationRef.current;
    ref.style.transform = `translate3d(-${distance}px, 0px, 0px)`;
    ref.style.transition = `transform 500ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s`;
    setTimeout(() => {
      ref.style.transition = null;
      ref.style.transform = null;
      parentRef.current.scrollLeft += distance;
      setScrolling(false);
    }, 400);
  }, [
    children.length,
    isScrolling,
    parentRef,
    presentationRef,
    sizing.itemWidth,
    sizing.limit,
  ]);

  const isDisabled =
    parentRef.current.scrollLeft >=
    presentationRef.current.offsetWidth - parentRef.current.offsetWidth;

  return (
    <div
      className={cx(actionClassName, rightActionClassName, {
        [disabledActionClassName]: isDisabled,
      })}
      dir="right"
      onClick={!isDisabled ? handleRight : undefined}
    >
      <i className={iconClassName}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path>
        </svg>
      </i>
    </div>
  );
}
